/* eslint-disable complexity */
import utils from "../../services/utils.js";
import algoliasearch from "algoliasearch/lite";
import Cart from "../shared/cart/cart.vue";
import Search from "./search/search.vue";
import Sidebar from "./sidebar.vue";
import ApplyMenu from "./dropdownMenus/Apply.vue";
import ShopMenu from "./dropdownMenus/Shop/Shop.vue";
import EditsMenu from "./dropdownMenus/Edits/Edits.vue";
import LoginMenu from "./dropdownMenus/LoginMenu/LoginMenu.vue";
import Refer from "./refer/refer.vue";
import NavigationApi from "../../services/api/NavigationApi";
import BrandApi from "../../services/api/brandApi";
import RetailerApi from "../../services/api/retailerApi";
import UserApi from "@/services/api/userApi";
import { mapGetters } from "vuex";

const NavigationApiService = new NavigationApi(),
  BrandApiService = new BrandApi(),
  RetailerApiService = new RetailerApi(),
  UserApiService = new UserApi();

export default {
  data() {
    return {
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      categories: [],
      edits: [],
      isSearchVisible: false,
      isMenuOpen: false,
      isSideBarOpen: false,
      hamburgerMenuToggle: false,
      dropdownMenu: [],
      firstName: "",
    };
  },

  methods: {
    getUserAccessLevel,
    focusEmailInput,
    redirect,
    logout,
    toggleMenu,
    toggleSideBar,
    toggleSearch,
    userLoggedInCallback,
    loadCategories,
    closeDropDown,
    closeSidebar,
    openRegisterModal,
    scrollToTop,
    onCartClicked,
    handleTrack,
    setFirstName,
  },

  components: {
    Refer,
    Cart,
    Search,
    Sidebar,
    ApplyMenu,
    ShopMenu,
    EditsMenu,
    LoginMenu,
  },

  computed: {
    ...mapGetters({
      user: "userState",
      plusAccess: "plusAccessState",
    }),
    shouldDisplayFeedLink() {
      // all roles or brand with access level
      return (
        (this.user !== null && this.user.role !== "BRAND") ||
        (this.user !== null && this.user.role === "BRAND" && this.plusAccess)
      );
    },
  },

  beforeMount() {
    this.searchIndexCollections = this.algoliaClient.initIndex(this.$env.getOrigin() + "_collections");

    this.loadCategories();
    this.$store.commit("setUser", this.$session.getUserInfo());
    this.setFirstName();
    this.getUserAccessLevel();
  },

  mounted() {
    this.$eventBus.$on("user-logged-in", this.userLoggedInCallback);
    this.$eventBus.$on("logout", this.logout);
    this.$eventBus.$on("navigation-updated", this.loadCategories);
    this.$eventBus.$on("close-navbar", () => {
      this.isSideBarOpen = false;
      this.hamburgerMenuToggle = false;
    });
  },

  beforeDestroy() {
    this.$eventBus.$off("user-logged-in", this.userLoggedInCallback);
    this.$eventBus.$off("logout", this.logout);
    this.$eventBus.$off("navigation-updated", this.loadCategories);
  },
};

function getUserAccessLevel() {
  if (this.user && this.user.role === "BRAND") {
    UserApiService.getBulletinPlusAccess().then((response) => {
      this.$store.commit("setPlusAccess", response.data.bulletin_plus_access_level);
    });
  }
}

function focusEmailInput() {
  this.$eventBus.$emit("focus-email-input");
}

export function redirect(item, type) {
  if (type === "collection") {
    const collectionURL = `/collections/${item.id}/products`;
    this.$router.push(collectionURL, () => this.$eventBus.$emit("init-search"));
  } else {
    const catName = utils.urlSafeString(item.name),
      categoryURL = `/category/${catName}/${item.id}/products`;
    this.$router.push(categoryURL, () => this.$eventBus.$emit("init-search"));
  }
}

export function openRegisterModal() {
  // this.$eventBus.$emit('showQuickShopModalUnregistered', null);
  this.$eventBus.$emit("apply-modal-unregistered", null);
}

function toggleMenu(menu) {
  if (this.isSearchVisible) {
    this.toggleSearch();
  }

  this.dropdownMenu = menu;
  this.isMenuOpen = true;
}

function toggleSideBar() {
  if (this.isSearchVisible) {
    this.toggleSearch();
  }

  // check if user is on dashboard because on dashboard we show different mobile menu
  if (this.$route.path.includes("dashboard")) {
    this.$eventBus.$emit("toggle-dashboard-sidebar");
  } else {
    this.isSideBarOpen = !this.isSideBarOpen;
  }
  this.hamburgerMenuToggle = !this.hamburgerMenuToggle;
}

function closeDropDown(event) {
  //prevent close if user hovers into navbar
  if (event && event.type === "mouseleave" && this.dropdownMenu === "login") {
    return;
  }

  if (event && event.relatedTarget && event.relatedTarget.id === "navbar") {
    return;
  }

  this.isMenuOpen = false;
  this.dropdownMenu = [];
}

function closeSidebar() {
  this.isSideBarOpen = false;
  this.hamburgerMenuToggle = false;
}

function toggleSearch() {
  this.isSearchVisible = !this.isSearchVisible;
  this.$eventBus.$emit("search-box-changed", this.isSearchVisible);
}

function userLoggedInCallback() {
  this.$store.commit("setUser", this.$session.getUserInfo());
  this.setFirstName();
}

// eslint-disable-next-line complexity
export function logout() {
  this.$eventBus.$emit("destroy-cart");
  this.$eventBus.$emit("unsubscribe-all");
  this.$store.commit("removeCheckoutState");
  if (window.talkSession) {
    window.talkSession.destroy();
  }

  this.$session.destroy();
  this.$store.commit("setUser", null);

  if (this.$route.name === undefined || this.$route.name === "home") {
    window.location.reload();
  } else {
    this.$router.push("/home");
    this.$forceUpdate();
  }
}

async function loadCategories() {
  this.categories = (await NavigationApiService.getNavigation()).data[0];
}

function onCartClicked() {
  if (this.isSearchVisible) {
    this.toggleSearch();
  }
  this.closeSidebar();
}

function scrollToTop() {
  document.getElementById("page_view").scrollIntoView({
    behavior: "smooth",
  });
}

function handleTrack(action) {
  this.$ma.trackEvent({
    action: action,
  });
}
async function setFirstName() {
  if (!this.$session.getUserInfo() || this.firstName !== "") {
    return;
  }
  const userRole = this.$session.getUserInfo().role;
  if (userRole === "BRAND") {
    const { data } = await BrandApiService.getBrandMe();
    this.firstName = data.first_name;
  }
  if (userRole === "RETAILER") {
    const { data } = await RetailerApiService.getMyRetailerInfo();
    this.firstName = data.first_name;
    this.$store.commit("setRetailerApproved", data.is_approved && !data.is_declined);
    this.$store.commit("setUserStatus", data.status);
  }
}
